import { Link } from 'react-router-dom';
import { useLanguage } from 'contexts/LanguageContext';
import NavBox from 'components/common/NavBox';
import { BuildingOfficeIcon, UserIcon } from '@heroicons/react/24/outline';

const SystemAdmin = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-800">{t('systemAdmin.title')}</h1>

      <div className="grid md:grid-cols-2 gap-4">
        <NavBox
          title={t('systemAdmin.box.users.title')}
          description={t('systemAdmin.box.users.description')}
          link="/system-admin/users"
          linkText={t('systemAdmin.box.users.link')}
          icon={<UserIcon />}
        />

        <NavBox
          title={t('systemAdmin.box.organizations.title')}
          description={t('systemAdmin.box.organizations.description')}
          link="/system-admin/organizations"
          linkText={t('systemAdmin.box.organizations.link')}
          icon={<BuildingOfficeIcon />}
        />
      </div>
    </div>
  );
};

export default SystemAdmin; 